import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useApi } from '../../hooks/useApi';
import { toast } from 'react-toastify';
import { useTitle } from '../../hooks/useTitle';
import Spinner from '../../components/Spinner';

const EmailChangeConfirm = () => {
  const { token } = useParams<{ token: string }>();
  const navigate = useNavigate();
  const { post, loading } = useApi();
  const [ confirmed, setConfirmed ] = useState(false);

  useTitle('Ton Bébé | メールアドレス変更確認');

  useEffect(() => {
    if (token && !confirmed) {
      post({
        endpoint: `api/v1/email_changes/confirm/${ token }`,
        method: 'PUT',
        skipAuth: true,
        onSuccess: (data) => {
          setConfirmed(true);
          toast.success('メールアドレスを変更しました。新しいメールアドレスでログインしてください。');
        },
        onError: (err) => {
          toast.error('トークンが無効または期限切れです。再度メールアドレス変更をお試しください。');
        },
        onFinally: () => {
          setTimeout(() => {
            navigate('/');
          }, 3000);
        }
      });
    }
  }, [ token, post, navigate, confirmed ]);

  return (
    <main className="sub">
      { loading && <Spinner overlay={ true } color="blue" /> }
      <section className="email-change-confirm">
        { confirmed ? (
          <div>
            <p>メールアドレスの変更が完了しました。</p>
            <p>3秒後にログイン画面に移動します。</p>
          </div>
        ) : (
          <p>メールアドレスの変更を処理しています...</p>
        ) }
      </section>
    </main>
  );
};

export default EmailChangeConfirm;
